import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dmcc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // don't force redirect during login
      if (!window.location.pathname.includes("/login") && !window.location.pathname.includes("/register")) {
        localStorage.removeItem("dmcc_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fmtNum = (n) => {
  if (n === null || n === undefined) return "0";
  const v = Number(n);
  if (Math.abs(v) >= 1_000_000_000) return (v / 1_000_000_000).toFixed(2) + "B";
  if (Math.abs(v) >= 1_000_000) return (v / 1_000_000).toFixed(2) + "M";
  if (Math.abs(v) >= 1_000) return (v / 1_000).toFixed(1) + "K";
  return v.toLocaleString("id-ID");
};

export const fmtIDR = (n) => {
  if (!n) return "Rp 0";
  const v = Number(n);
  if (v >= 1_000_000_000) return "Rp " + (v / 1_000_000_000).toFixed(2) + " M";
  if (v >= 1_000_000) return "Rp " + (v / 1_000_000).toFixed(1) + " Jt";
  if (v >= 1_000) return "Rp " + (v / 1_000).toFixed(0) + "rb";
  return "Rp " + v.toLocaleString("id-ID");
};
